export default "__VITE_ASSET__CAmb_2Q___"